/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { salesStandardProductConversionFieldsCreate } from '../fn/sales/sales-standard-product-conversion-fields-create';
import { salesStandardProductConversionFieldsCreate$FormData } from '../fn/sales/sales-standard-product-conversion-fields-create-form-data';
import { SalesStandardProductConversionFieldsCreate$FormData$Params } from '../fn/sales/sales-standard-product-conversion-fields-create-form-data';
import { SalesStandardProductConversionFieldsCreate$Params } from '../fn/sales/sales-standard-product-conversion-fields-create';
import { salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded } from '../fn/sales/sales-standard-product-conversion-fields-create-x-www-form-urlencoded';
import { SalesStandardProductConversionFieldsCreate$XWwwFormUrlencoded$Params } from '../fn/sales/sales-standard-product-conversion-fields-create-x-www-form-urlencoded';
import { salesStandardProductConversionFieldsList } from '../fn/sales/sales-standard-product-conversion-fields-list';
import { SalesStandardProductConversionFieldsList$Params } from '../fn/sales/sales-standard-product-conversion-fields-list';
import { BackendStandartProductConversionFieldDto } from '../models/backend-standart-product-conversion-field-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiSalesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `salesStandardProductConversionFieldsList()` */
  static readonly SalesStandardProductConversionFieldsListPath = '/api/sales/standard-product-conversion-fields/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductConversionFieldsList$Response(
    params?: SalesStandardProductConversionFieldsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendStandartProductConversionFieldDto>>> {
    return salesStandardProductConversionFieldsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  salesStandardProductConversionFieldsList(
    params?: SalesStandardProductConversionFieldsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendStandartProductConversionFieldDto>> {
    return this.salesStandardProductConversionFieldsList$Response(params, context).pipe(
      map(
        (
          r: BakendHttpResponse<Array<BackendStandartProductConversionFieldDto>>,
        ): Array<BackendStandartProductConversionFieldDto> => r.body,
      ),
    );
  }

  /** Path part for operation `salesStandardProductConversionFieldsCreate()` */
  static readonly SalesStandardProductConversionFieldsCreatePath = '/api/sales/standard-product-conversion-fields/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductConversionFieldsCreate$Response(
    params: SalesStandardProductConversionFieldsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  salesStandardProductConversionFieldsCreate(
    params: SalesStandardProductConversionFieldsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsCreate$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded$Response(
    params: SalesStandardProductConversionFieldsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded(
    params: SalesStandardProductConversionFieldsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `salesStandardProductConversionFieldsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductConversionFieldsCreate$FormData$Response(
    params: SalesStandardProductConversionFieldsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendStandartProductConversionFieldDto>> {
    return salesStandardProductConversionFieldsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `salesStandardProductConversionFieldsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  salesStandardProductConversionFieldsCreate$FormData(
    params: SalesStandardProductConversionFieldsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendStandartProductConversionFieldDto> {
    return this.salesStandardProductConversionFieldsCreate$FormData$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendStandartProductConversionFieldDto>): BackendStandartProductConversionFieldDto =>
          r.body,
      ),
    );
  }
}
